"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RichText_1 = require("./RichText");
exports.default = RichText_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/RichText/index.js
// module id = 825
// module chunks = 8